if ( typeof CountdownClock !== 'function' ) {

  class CountdownClock extends HTMLElement {

    constructor(){
      super();
      this.init();
    }

    init(){

      this.daysEl = this.querySelector('.days');
      this.hoursEl = this.querySelector('.hours');
      this.minutesEl = this.querySelector('.minutes');
      this.secondsEl = this.querySelector('.seconds');

      const date = this.dataset.date.split(','); // [year, month, day, hour]
      const gmt = parseInt(this.dataset.timezone);
      const timezone = (new Date()).getTimezoneOffset() / -60; // visitor offset (handles DST)
      const daily = (this.dataset.daily === 'true');

      const hour = parseInt(date[3]) || 0;

      // Build target time
      if (daily) {
        // Next occurrence of selected hour, adjusted for selected GMT vs visitor TZ
        const now = new Date();
        let target = new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          hour, 0, 0, 0
        );

        // Align to selected GMT (keep existing theme behavior)
        target.setHours(target.getHours() + (timezone - gmt));

        // If already passed today, move to tomorrow
        if (now >= target) target.setDate(target.getDate() + 1);

        this.COUNT = target;
      } else {
        // Original one-off countdown behavior
        this.COUNT = new Date(date[0], (date[1]-1), date[2], hour);
        if ( timezone != gmt ) {
          this.COUNT.setHours(hour + timezone - gmt);
        }
      }

      this._countdownBannerInterval = setInterval(this._countEachSecond.bind(this), 1000);
      this._countEachSecond();
      if ( this.classList.contains('hide') ) {
        this.classList.remove('hide');
      }
    }

    _countEachSecond(){

      const now = new Date().getTime(),
            distance = this.COUNT - now;

      const days = Math.floor(distance / (1000 * 60 * 60 * 24)),
            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
            seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.daysEl.innerHTML    = days    < 10 ? `<span>0</span><span>${days}</span>`       : days.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
      this.hoursEl.innerHTML   = hours   < 10 ? `<span>0</span><span>${hours}</span>`      : hours.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
      this.minutesEl.innerHTML = minutes < 10 ? `<span>0</span><span>${minutes}</span>`    : minutes.toString().split('').map(digit=>`<span>${digit}</span>`).join("");
      this.secondsEl.innerHTML = seconds < 10 ? `<span>0</span><span>${seconds}</span>`    : seconds.toString().split('').map(digit=>`<span>${digit}</span>`).join("");

      if ( distance <= 0 ) {
        // If daily mode, roll forward 1 day at the same hour
        if (this.dataset.daily === 'true') {
          this.COUNT.setDate(this.COUNT.getDate() + 1);
          return; // continue ticking without clearing
        }
        // One-off mode: stop at 00:00:00
        clearInterval(this._countdownBannerInterval);
        this.daysEl.innerHTML    = '<span>0</span><span>0</span>';
        this.hoursEl.innerHTML   = '<span>0</span><span>0</span>';
        this.minutesEl.innerHTML = '<span>0</span><span>0</span>';
        this.secondsEl.innerHTML = '<span>0</span><span>0</span>';
      }
    }

  }

  if ( typeof customElements.get('countdown-clock') == 'undefined' ) {
    customElements.define('countdown-clock', CountdownClock);
  }

}
